import { takeEvery, call, put } from 'redux-saga/effects';
import * as UrlUtil from '../utils/UrlUtil';
import { gcApi } from '../config/axios';
import {
    FETCH_USER_STATS_WELLNESS_DAILY,
    FETCH_USER_STATS_WELLNESS_DAILY_FETCHING,
    FETCH_USER_STATS_WELLNESS_DAILY_SUCCESS,
    FETCH_USER_STATS_WELLNESS_DAILY_FAIL,
    FETCH_USER_STATS_WELLNESS_WEEKLY,
    FETCH_USER_STATS_WELLNESS_WEEKLY_FETCHING,
    FETCH_USER_STATS_WELLNESS_WEEKLY_SUCCESS,
    FETCH_USER_STATS_WELLNESS_WEEKLY_FAIL,
    FETCH_USER_STATISTICS,
    FETCH_MONTHLY_REPORT,
    REQUEST_DAILY_STEPS_REPORT,
    REQUEST_LIFETIME_STEPS_REPORT,
    REQUEST_MONTHLY_STEPS_REPORT,
    RECEIVE_DAILY_STEPS_REPORT,
    RECEIVE_LIFETIME_STEPS_REPORT,
    RECEIVE_MONTHLY_STEPS_REPORT,
    FETCH_STEPS_REPORT,
    FETCH_ACTIVITIES_365_REPORT,
    FETCH_USER_STATS_WELLNESS_MONTHLY_FETCHING,
    FETCH_USER_STATS_WELLNESS_MONTHLY_SUCCESS,
    FETCH_USER_STATS_WELLNESS_MONTHLY_FAIL,
    FETCH_USER_STATS_WELLNESS_MONTHLY
} from '../actions/ActionTypes';

import {
    receiveActivities365Report,
    receiveStepsReport,
    receiveUserStatistics,
    requesActivities365Report,
    requestMonthlyReport,
    requestStepsReport,
    requestUserStatistics
} from '../actions';
import { receiveMonthlyReport } from '../actions/index';

// Workers
export function* fetchUserStatsWellnessDailySaga(action) {
    try {
        yield put({
            type: FETCH_USER_STATS_WELLNESS_DAILY_FETCHING
        });

        const { displayName, fromLabel, startDate, untilLabel, endDate, metricIds, grpParentActType } = action.payload;

        const queryParams = UrlUtil.toQueryString({
            [fromLabel]: startDate,
            [untilLabel]: endDate,
            grpParentActType,
            metricId: metricIds // Array of metric IDs
        });

        const response = yield call(gcApi.get, `/userstats-service/wellness/daily/${displayName}${queryParams}`);

        yield put({
            type: FETCH_USER_STATS_WELLNESS_DAILY_SUCCESS,
            userStatsWellnessDaily: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_STATS_WELLNESS_DAILY_FAIL,
            userStatsWellnessDaily: null
        });
    }
}

export function* fetchUserStatsWellnessWeeklySaga(action) {
    try {
        yield put({
            type: FETCH_USER_STATS_WELLNESS_WEEKLY_FETCHING
        });

        const { displayName, fromLabel, startDate, untilLabel, endDate, metricIds, grpParentActType } = action.payload;

        const queryParams = UrlUtil.toQueryString({
            [fromLabel]: startDate,
            [untilLabel]: endDate,
            grpParentActType,
            metricId: metricIds // Array of metric IDs
        });

        const response = yield call(gcApi.get, `/userstats-service/wellness/weekly/${displayName}${queryParams}`);

        yield put({
            type: FETCH_USER_STATS_WELLNESS_WEEKLY_SUCCESS,
            userStatsWellnessWeekly: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_STATS_WELLNESS_WEEKLY_FAIL,
            userStatsWellnessWeekly: null
        });
    }
}

export function* fetchUserStatsWellnessMonthlySaga(action) {
    try {
        yield put({
            type: FETCH_USER_STATS_WELLNESS_MONTHLY_FETCHING
        });

        const { displayName, fromLabel, startDate, untilLabel, endDate, metricIds, grpParentActType } = action.payload;

        const queryParams = UrlUtil.toQueryString({
            [fromLabel]: startDate,
            [untilLabel]: endDate,
            grpParentActType,
            metricId: metricIds // Array of metric IDs
        });

        const response = yield call(gcApi.get, `/userstats-service/wellness/monthly/${displayName}${queryParams}`);

        yield put({
            type: FETCH_USER_STATS_WELLNESS_MONTHLY_SUCCESS,
            userStatsWellnessMonthly: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_STATS_WELLNESS_MONTHLY_FAIL,
            userStatsWellnessMonthly: null
        });
    }
}

export function* fetchUserStatisticsSaga({ displayName }) {
    try {
        yield put(requestUserStatistics());
        const response = yield gcApi.get(`/userstats-service/statistics/${displayName}`);
        yield put(receiveUserStatistics(response.data, displayName));
    } catch (e) {}
}

export function* fetchMonthlyReportSaga({ displayName }) {
    try {
        yield put(requestMonthlyReport(displayName));
        const response = yield gcApi.get(`/userstats-service/statistics/monthly/${displayName}?ByParentType=true`);
        yield put(receiveMonthlyReport(displayName, response.data));
    } catch (e) {}
}

export function* fetchStepsReportSaga({ period, displayName, startDate, endDate, lifetimeSteps }) {
    try {
        let fromLabel, toLabel;
        if (period === 'daily' && !lifetimeSteps) {
            yield put(requestStepsReport(REQUEST_DAILY_STEPS_REPORT, displayName));
            fromLabel = 'fromDate';
            toLabel = 'untilDate';
        } else if (period === 'daily' && lifetimeSteps) {
            yield put(requestStepsReport(REQUEST_LIFETIME_STEPS_REPORT, displayName));
            fromLabel = 'fromDate';
            toLabel = 'untilDate';
        } else {
            yield put(requestStepsReport(REQUEST_MONTHLY_STEPS_REPORT, displayName));
            fromLabel = 'fromMonthStartDate';
            toLabel = 'untilMonthStartDate';
        }

        const url = `/userstats-service/wellness/${period}/${displayName}?${fromLabel}=${startDate}&${toLabel}=${endDate}&grpParentActType=false`;
        const response = yield gcApi.get(url);

        if (period === 'daily' && !lifetimeSteps) {
            yield put(receiveStepsReport(RECEIVE_DAILY_STEPS_REPORT, displayName, response.data));
        } else if (period === 'daily' && lifetimeSteps) {
            yield put(receiveStepsReport(RECEIVE_LIFETIME_STEPS_REPORT, displayName, response.data));
        } else {
            yield put(receiveStepsReport(RECEIVE_MONTHLY_STEPS_REPORT, displayName, response.data));
        }
    } catch (e) {}
}

export function* fetchActivities365ReportSaga({ displayName }) {
    try {
        yield put(requesActivities365Report(displayName));
        const response = yield gcApi.get(`/userstats-service/statistics/previousDays/${displayName}`);
        yield put(receiveActivities365Report(displayName, response.data));
    } catch (e) {}
}

// Watcher
export const userStatsSagas = [
    takeEvery(FETCH_USER_STATS_WELLNESS_DAILY, fetchUserStatsWellnessDailySaga),
    takeEvery(FETCH_USER_STATS_WELLNESS_WEEKLY, fetchUserStatsWellnessWeeklySaga),
    takeEvery(FETCH_USER_STATS_WELLNESS_MONTHLY, fetchUserStatsWellnessMonthlySaga),
    takeEvery(FETCH_USER_STATISTICS, fetchUserStatisticsSaga),
    takeEvery(FETCH_MONTHLY_REPORT, fetchMonthlyReportSaga),
    takeEvery(FETCH_STEPS_REPORT, fetchStepsReportSaga),
    takeEvery(FETCH_ACTIVITIES_365_REPORT, fetchActivities365ReportSaga)
];
